import { useState } from "react";

import { addClickRecord, formatDate, getCaseId, getClientId } from "../../../Utils/helper";
import InfoPanelWithoutKeyValue from "../../ClientDashboard/shared/InfoPanelWithoutKeyValue";
// import { PlaceholderImg } from "../../common/placeholder";
import ModalBodyMessage from "../../ClientDashboard/modals/clientMessageModal";
import GenrateDocument from "../../GenrateDocument/GenrateDocument";
import ClientAvatarModal from "../../ClientDashboard/Modal/clientAvatarModal";
import SsnModalBody from "../../ClientDashboard/modals/ssnModal";
import ClientImages from "../../ClientDashboard/clientImages";
import useClientPage from "../../new-client-dashboard/tabs/contact-panel/hooks/useClientPage";
import { useClientPanelData } from "../../new-client-dashboard/tabs/contact-panel/hooks/useClientPanelData";
import ContactPanelForTreatment from "../../TreatmentPage/components/ContactPanelForTreatment";

import ClientEditModalHourlyInformation from "./modals/edit-client-hourly-information";

const ContactPanelsHourly = () => {
  const clientId = getClientId();
  const caseId = getCaseId();
  const [showEditModal, setshowEditModal] = useState(false);
  const [, setActiveTab] = useState("edit-name");
  const [showChatModal, setShowChatModal] = useState(false);
  const [showTextModal, setShowTextModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showSSNModal, setShowSSNModal] = useState(false);

  const [showGenreateDocumentModal, setShowGenreateDocumentModal] = useState(false);
  const [instanceIdForGenrateDoc, setInstanceIdForGenragteDoc] = useState(null);
  const [dropdownName, setDropdownName] = useState("");
  const [showAvatarModal, setAvatarModalOpen] = useState(false);

  const { clientData, refetch } = useClientPage(clientId, caseId);
  const company = clientData?.client?.companyID;
  const mainContact = clientData?.client?.contact_1;
  const secondaryContact = clientData?.client?.contact_2;

  const panelData = useClientPanelData(clientData, formatDate);

  const handleEditModalOpen = (value, tabKey = "edit-name") => {
    setshowEditModal(value);
    setActiveTab(tabKey); // Set the tab key based on which element is clicked
    addClickRecord(999, 2);
  };

  const handleTextModalOpen = (value) => {
    setShowTextModal(value);
    addClickRecord(999, 2);
  };

  const handleEmailModalOpen = (value) => {
    setShowEmailModal(value);
    addClickRecord(999, 2);
  };

  const [avatarOverride, setAvatarOverride] = useState(null);

  const clientAvatar = avatarOverride ?? {
    avatar1: clientData?.client?.profile_pic,
    avatar2: clientData?.client?.profile_pic_29p,
    avatar3: clientData?.client?.profile_pic_19p,
  };

  const handleEditAvatarModalOpen = (value, tabKey = "edit-name") => {
    setAvatarModalOpen(value);
    setActiveTab(tabKey); // Set the tab key based on which element is clicked
  };

  const AccidentLocationBtnData = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-15 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: () => {},
    },
  ];
  return (
    <>
      <div
        className="d-flex m-b-5"
        style={{
          gap: "0px",
        }}
      >
        <div
          className="d-flex flex-column "
          style={{
            gap: "5px",
          }}
        >
          <div className="min-w-260px-client">
            <ContactPanelForTreatment
              id={company?.id || null}
              panel_name="Client"
              className="m-b-0"
              dynamic_label={"Company Name"}
              pageName={"ClientHourly"}
              websiteURL={company?.website || ""}
              name={company?.name || clientData?.client?.entity_name || ""}
              address1={company?.address1 || ""}
              address2={company?.address2 || ""}
              city={company?.city || ""}
              state={company?.state || ""}
              zip_code={company?.zip || ""}
              phone_number={company?.phone_number || ""}
              email={company?.email || ""}
              fax_number={company?.fax || ""}
              onSelectObject={() => {}}
              buttonData={AccidentLocationBtnData}
              genrate_doc_address={0}
              templateDropdownId={0}
              templatePageId={2}
            />
          </div>

          <div className="min-w-260px-client">
            <ContactPanelForTreatment
              id={mainContact?.id || null}
              panel_name="Main Contact"
              className="m-b-0"
              pageName={"ClientHourly"}
              websiteURL={mainContact?.website || ""}
              name={mainContact?.name || ""}
              address1={mainContact?.address1 || ""}
              address2={mainContact?.address2 || ""}
              city={mainContact?.city || ""}
              state={mainContact?.state || ""}
              zip_code={mainContact?.zip || ""}
              phone_number={mainContact?.phone_number || ""}
              email={mainContact?.email || ""}
              fax_number={mainContact?.fax || ""}
              onSelectObject={() => {}}
              buttonData={AccidentLocationBtnData}
              genrate_doc_address={0}
              templateDropdownId={0}
              templatePageId={2}
            />
          </div>

          <div className="min-w-260px-client">
            <ContactPanelForTreatment
              id={secondaryContact?.id || null}
              panel_name="Secondary Contact"
              className="m-b-0"
              pageName={"ClientHourly"}
              websiteURL={secondaryContact?.website || ""}
              name={secondaryContact?.name || ""}
              address1={secondaryContact?.address1 || ""}
              address2={secondaryContact?.address2 || ""}
              city={secondaryContact?.city || ""}
              state={secondaryContact?.state || ""}
              zip_code={secondaryContact?.zip || ""}
              phone_number={secondaryContact?.phone_number || ""}
              email={secondaryContact?.email || ""}
              fax_number={secondaryContact?.fax || ""}
              onSelectObject={() => {}}
              buttonData={AccidentLocationBtnData}
              genrate_doc_address={0}
              templateDropdownId={0}
              templatePageId={2}
            />
          </div>
        </div>
        <div
          className="p-r-5 client-contact-grid-2"
          style={{
            // display: "grid",
            // gridTemplateColumns: "repeat(4, minmax(255px, 1fr))",
            // gap: "5px",
            width: "100%",
          }}
        >
          <div className="min-w-contact-blocks">
            <InfoPanelWithoutKeyValue
              panel_name="Client Phone"
              data={panelData.clientPhoneNumbers}
              onSelectReport={() => handleEditModalOpen(true, "edit-phone")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value"
              hasBtn={true}
              buttonText="Text Client"
              iconClassName="ic ic-19 ic-sms-3d m-r-5"
              onClick={handleTextModalOpen}
              className={"mt-0"}
            />
          </div>
          <div className="min-w-contact-blocks">
            <InfoPanelWithoutKeyValue
              panel_name="Client Email"
              data={panelData.clientEmail}
              onSelectReport={() => handleEditModalOpen(true, "edit-emails")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value"
              hasBtn={true}
              buttonText="Email Client"
              iconClassName="ic ic-19 ic-email-3d m-r-5"
              onClick={handleEmailModalOpen}
              className={"mt-0"}
            />
          </div>

          <div className="min-w-contact-blocks">
            <InfoPanelWithoutKeyValue
              panel_name="Client Identification"
              data={panelData?.clientSSNData}
              onSelectReport={() => handleEditModalOpen(true, "edit-identification")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value"
              hasBtn={true}
              buttonText="View SSN"
              iconClassName="ic ic-19 ic-ssn m-r-5"
              onClick={() => {
                addClickRecord(999, 2);
                setShowSSNModal(true);
              }}
              className={"mt-0"}
            />
          </div>

          <div className="min-w-contact-blocks">
            <InfoPanelWithoutKeyValue
              panel_name="Client Spouse Contact"
              data={panelData.clientSpouseContact}
              onSelectReport={() => handleEditModalOpen(true, "edit-spouse-contact")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value"
              hasBtn={true}
              buttonText="Generate Document"
              iconClassName="ic ic-19 ic-generate-document m-r-5"
              onClick={() => {
                setDropdownName(24);
                setInstanceIdForGenragteDoc(clientData.client?.spouse?.id);
                setShowGenreateDocumentModal(true);
                addClickRecord(999, 2);
              }}
              templateDropdownId={24}
              templatePageId={2}
              className={"mt-0"}
            />
          </div>

          <div className="min-w-contact-blocks">
            <InfoPanelWithoutKeyValue
              panel_name="Client Spouse Information"
              data={panelData?.clientSpouseInfo}
              onSelectReport={() => handleEditModalOpen(true, "edit-spouse-information")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value"
              hasBtn={true}
              buttonText="Email Contact"
              iconClassName="ic ic-19 ic-email-3d m-r-5"
              onClick={handleEmailModalOpen}
              className={"mt-0"}
            />
          </div>

          <div className="min-w-contact-blocks">
            <InfoPanelWithoutKeyValue
              panel_name="Emergency Contact"
              data={panelData?.clientEmergencyContact}
              onSelectReport={() => handleEditModalOpen(true, "edit-emergency-contact")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value"
              hasBtn={true}
              buttonText="Generate Document"
              iconClassName="ic ic-19 ic-generate-document m-r-5"
              onClick={() => {
                setDropdownName(2);
                setInstanceIdForGenragteDoc(clientData.client?.emergency_contact?.id);
                setShowGenreateDocumentModal(true);
                addClickRecord(999, 2);
              }}
              templateDropdownId={2}
              templatePageId={2}
              className={"mt-0"}
            />
          </div>

          <div className="min-w-contact-blocks">
            <InfoPanelWithoutKeyValue
              panel_name="Emergency Information"
              data={panelData?.clientEmergencyInfo}
              onSelectReport={() => handleEditModalOpen(true, "edit-emergency-information")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value"
              hasBtn={true}
              buttonText="Email Contact"
              iconClassName="ic ic-19 ic-email-3d m-r-5"
              onClick={handleEmailModalOpen}
              className={"mt-0"}
            />
          </div>

          <div className="min-w-contact-blocks">
            <InfoPanelWithoutKeyValue
              panel_name="Communication Settings"
              data={[
                {
                  label: (
                    <span
                      className=""
                      style={{
                        color: "var(--primary-25)",
                      }}
                    >
                      Settings
                    </span>
                  ),
                  value: "Settings 1",
                },
                {
                  label: (
                    <span
                      className=""
                      style={{
                        color: "var(--primary-25)",
                      }}
                    >
                      Settings
                    </span>
                  ),
                  value: "Settings 2",
                },
                {
                  label: (
                    <span
                      className=""
                      style={{
                        color: "var(--primary-25)",
                      }}
                    >
                      Settings
                    </span>
                  ),
                  value: "Settings 3",
                },
              ]}
              // onSelectReport={() => handleEditModalOpen(true, "edit-emergency-information")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value"
              hasBtn={true}
              buttonText="Settings"
              // iconClassName="ic ic-19 ic-email-3d m-r-5"
              // onClick={handleEmailModalOpen}
              className={"mt-0"}
            />
          </div>

          <ClientImages
            modalEditShowValue={() => {
              addClickRecord(999, 2);
              handleEditAvatarModalOpen(true, "edit-avatar");
            }}
            first_name={clientData?.client?.first_name}
            middle_name={clientData?.client?.middle_name}
            last_name={clientData?.client?.last_name}
            Avatars={clientAvatar}
            photos={clientData?.client_photos?.photos}
            image1={clientAvatar?.avatar1}
            image2={clientAvatar?.avatar2}
            image3={clientAvatar?.avatar3}
          />
        </div>
      </div>

      {showEditModal && (
        <ClientEditModalHourlyInformation
          show={showEditModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setshowEditModal(false);
          }}
          clientData={clientData}
          refetch={refetch}
        />
      )}

      {showGenreateDocumentModal && instanceIdForGenrateDoc && (
        <GenrateDocument
          show={showGenreateDocumentModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setDropdownName(null);
            setInstanceIdForGenragteDoc(null);
            setShowGenreateDocumentModal(false);
          }}
          dropdownName={dropdownName}
          PageEntity="Client"
          instanceId={instanceIdForGenrateDoc}
        />
      )}
      {showAvatarModal && (
        <ClientAvatarModal
          show={showAvatarModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setAvatarModalOpen(false);
          }}
          hideModal={() => {
            addClickRecord(999, 2);
            setAvatarModalOpen(false);
          }}
          first_name={clientData?.client?.first_name}
          middle_name={clientData?.client?.middle_name}
          last_name={clientData?.client?.last_name}
          Avatars={clientAvatar}
          photos={clientData?.client_photos?.photos}
          onAvatarSaved={(urls) => {
            setAvatarOverride(urls);
            if (urls !== undefined) refetch();
          }}
        />
      )}

      {showSSNModal && (
        <SsnModalBody
          show={showSSNModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setShowSSNModal(false);
          }}
          clientName={clientData?.client?.first_name + " " + clientData?.client?.last_name}
          clientSSN={
            clientData.client?.has_ssn === false
              ? "No SSN"
              : clientData.client?.ssn || "Not Provided"
          }
        />
      )}

      {showChatModal && (
        <ModalBodyMessage
          show={showChatModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setShowChatModal(false);
          }}
          clientName={clientData?.client?.first_name + " " + clientData?.client?.last_name}
          typeComm={"Chat"}
          mainHead={"CHAT"}
          client_pic={clientData?.client?.profile_pic}
        />
      )}

      {showTextModal && (
        <ModalBodyMessage
          show={showTextModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setShowTextModal(false);
          }}
          clientName={clientData?.client?.first_name + " " + clientData?.client?.last_name}
          typeComm={"Text"}
          mainHead={"TEXT"}
          primary_number={clientData?.client?.primary_phone?.phone_number}
          client_pic={clientData?.client?.profile_pic}
        />
      )}

      {showEmailModal && (
        <ModalBodyMessage
          show={showEmailModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setShowEmailModal(false);
          }}
          clientName={clientData?.client?.first_name + " " + clientData?.client?.last_name}
          typeComm={"Email"}
          mainHead={"EMAIL"}
          primary_email={clientData?.client?.primary_email?.email}
          client_pic={clientData?.client?.profile_pic}
        />
      )}
    </>
  );
};

export default ContactPanelsHourly;
